import { createSlice } from '@reduxjs/toolkit';
import { InboxMessage } from 'modules/types/Inbox';
import {
  fetchInboxMessages,
  fetchUnreadMessageCount,
  markInboxMessageAsRead,
} from './thunks';

export interface InboxState {
  messages?: InboxMessage[];
  loadingMessages?: boolean;
  loadingMessagesError?: string;
  totalPageCount?: number;
  unreadMessageCount: number;
}

const initialState: InboxState = {
  messages: [],
  loadingMessages: true,
  loadingMessagesError: undefined,
  totalPageCount: 1,
  unreadMessageCount: 0,
};

export const inboxSlice = createSlice({
  name: 'inbox',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch inbox messages

    builder.addCase(fetchInboxMessages.pending, (state) => {
      state.loadingMessages = initialState.loadingMessages;
      state.messages = initialState.messages;
      state.loadingMessagesError = initialState.loadingMessagesError;
      state.totalPageCount = initialState.totalPageCount;
    });

    builder.addCase(fetchInboxMessages.fulfilled, (state, action) => {
      state.loadingMessages = false;
      state.messages = action.payload.messages;
      state.totalPageCount = action.payload.totalPageCount;
    });

    builder.addCase(fetchInboxMessages.rejected, (state, action) => {
      state.loadingMessages = false;
      state.loadingMessagesError = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });

    // fetch unread message count

    builder.addCase(fetchUnreadMessageCount.fulfilled, (state, action) => {
      state.unreadMessageCount = action.payload;
    });

    // mark inbox message as read
    builder.addCase(markInboxMessageAsRead.fulfilled, (state, action) => {
      const readMessageId = action.payload;

      state.messages = state.messages?.map((message) => {
        if (message.id === readMessageId) {
          if (message.read === false) {
            message.read = true;
            state.unreadMessageCount -= 1;
          }
        }

        return message;
      });
    });
  },
});

export default inboxSlice.reducer;
